import React, { useEffect } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import ProductItem from "./components/ProductItem";
// At the very top of your file
import { Link } from "react-router-dom";



const Index = () => {
    const [storedName] = useLocalStorage("name", null);
    const { brandData, loading, errors } = useTraceabilityData();

    // Log brand data when it's available
    useEffect(() => {
        if (brandData) {
            // eslint-disable-next-line no-console
            console.log('Brand Logo Data from Context:', brandData);
        }
        if (errors.brand) {
            // eslint-disable-next-line no-console
            console.error('Brand Logo Error:', errors.brand);
        }
    }, [brandData, errors.brand]);

    return (


        <div className="">


            <div className="wrapper2">
                <h2 className="heading2">Your Traceability Journey</h2>
            </div>

            <div className="bg-light">
                <div className="container p-3">
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="m-0">Popular Products</h6>
                        <a href="listing.html">View all<i className="icofont-rounded-right"></i></a>
                    </div> */}
                    <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">

                        <ProductItem
                            href="/dairy-farm"
                            imageSrc="img/box1.png"
                            stepNumber="01"
                            title="Dairy Farms"
                            description="Every batch begins with fresh milk collected from our trusted peers."
                        />

                        <ProductItem
                            href="/milk-grading"
                            imageSrc="img/box2.png"
                            stepNumber="02"
                            title="Milk Grading"
                            description="Ensuring fair pricing and top-quality milk through meticulous grading."
                        />

                        <ProductItem
                            href="/quality-check"
                            imageSrc="img/box3.png"
                            stepNumber="03"
                            title="Quality Check"
                            description="Rigorous testing of the milk to guarantee purity and freshness."
                        />

                        <ProductItem
                            href="/manufacturing"
                            imageSrc="img/box4.png"
                            stepNumber="04"
                            title="Manufacturing"
                            description="Advanced technology transforms raw milk into the highest quality product."
                        />

                        <ProductItem
                            href="/distribution"
                            imageSrc="img/box5.png"
                            stepNumber="05"
                            title="Distribution"
                            description="Delivering fresh products to you swiftly and efficiently."
                        />

                        <ProductItem
                            href="/it-is-you"
                            imageSrc="img/box6.png"
                            stepNumber="06"
                            title={` It's ${storedName || 'you'}! `}
                            description="Fresh, quality products crafted with care and delivered with trust—just for you."
                        />

                    </div>
                    {/* Previous / Next buttons below grid */}
                    {/* <div className="flex justify-between mt-10 mb-2 gap-10 sm:px-0">
                        <Link
                            to="/home"
                            className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                        >
                            Previous
                        </Link>
                        <Link
                            to="/meet-our-cows"
                            className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                        >
                            Next
                        </Link>

                    </div> */}


                </div>
            </div>

        </div>


    );
};

export default Index;
